<script>
	export let title = "See the data";
</script>

<style></style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.23 56.63" role="img">
	<title>{title}</title>
	<path
		d="M25.79,.41H.41V56.22H40.82V15.44L25.79,.41Zm1.53,5.77l7.77,7.77h-7.77V6.18ZM3.41,53.22V3.41H24.31V15.44c0,.83,.67,1.5,1.5,1.5h12.01V53.22H3.41Z" /><path
		d="M33.33,34.29H8.23c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5h25.09c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5Z" /><path
		d="M8.23,27.29h14c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5H8.23c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5Z" /><path
		d="M8.23,17.28h10.07c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5H8.23c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5Z" /><path
		d="M13.22,44.29h-4.99c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5h4.99c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5Z" /><path
		d="M23.2,44.29h-4.99c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5h4.99c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5Z" /><path
		d="M33.18,44.29h-4.99c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5h4.99c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5Z" /><path
		d="M33.33,24.29h-7.3c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5h7.3c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5Z" />
</svg>
